import { useMutation } from '@tanstack/react-query'
import { requestFakeDoorInsights } from '../services'

export const useRequestFakedoorInsights = () => {
  return useMutation({
    mutationFn: requestFakeDoorInsights,
  })
}
